<template>
  <div>
    <h3 class="title is-3" style="margin-top:8px;">
      <router-link to="/tools/explorer">
        <b-icon icon="chevron-left" size="is-small"></b-icon>
      </router-link>
      &nbsp;
      {{sport}} - Spotlight
    </h3>

    <div
      class="notification is-warning"
      v-if="data === false"
    >Seems like there was a problem retrieving the data.</div>
    <loading v-else-if="!data"></loading>
    <div class="box" v-else>
      <h5 class="title is-5">Data</h5>
      <tree-view :data="data" :options="{rootObjectKey: `${sport} Featured`}"></tree-view>
    </div>
  </div>
</template>

<script>
import { GET_EXPLORER_DATA } from "@/store/actions";
import { SET_EXPLORER_DATA } from "@/store/mutations";
import Loading from "@/components/Loading";

export default {
  name: "feed-explorer-spotlight",
  components: {
    Loading
  },
  mounted() {
    this.$store.commit(SET_EXPLORER_DATA, {});
    this.get();
  },
  computed: {
    sport() {
      return this.$route.params.sport;
    },
    data() {
      return this.$store.state.explorer.data;
    }
  },
  methods: {
    get() {
      let url = "supersport://spotlight?type=feature";
      if (this.sport !== "All") {
        url = `supersport://${this.sport.toLowerCase()}/spotlight/?type=feature`;
      }
      this.$store.dispatch(GET_EXPLORER_DATA, url);
    }
  }
};
</script>

<style>
.tree-view-item-value-null {
  color: crimson;
}
.tree-view-item-value-number {
  color: blueviolet;
}
.tree-view-item-value-string {
  color: green;
}
.tree-view-item-value-boolean {
  color: blue;
}
</style>
